import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { useUpdateTask } from "@api/task.api";
import { memo } from "react";
import { useWorkspaceCloses } from "@api/close.api";
import { useScope } from "@state/scopeContext.lib";
import { NestedTaskRow } from "../../types";
import { getServiceUpdate } from "../../taskClose";
import { CloseSelectCell } from "./CloseSelectCell";

export const CloseCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        NestedTaskRow,
        Task["closeId"] | null
    >) => {
        const task = row.original as Task;
        const updateTask = useUpdateTask(task);
        const { data: closes = [] } = useWorkspaceCloses();
        const { organizationId } = useScope();

        if (
            row.original.isGroup ||
            row.original.isNewPlaceholder ||
            !organizationId ||
            closes.length === 0
        ) {
            return null;
        }

        return (
            <CloseSelectCell
                value={task.closeId ?? null}
                items={closes}
                addText="Add service"
                nullLabel="No service"
                onValueChange={(value) =>
                    updateTask.mutate(getServiceUpdate(value))
                }
            />
        );
    },
);
